export const versionUpdate = {
  title: 'Hay una nueva versión disponible',
  description: 'Recargá la página para obtener las últimas mejoras.',
  reload: 'Recargar',
  dismiss: 'Cerrar',
} as const
